import React, {useEffect, useState} from 'react'
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import FrameWorksListView from "../../views/ver_24.10/FrameWorks/FrameWorksList.view";

const FrameWorksList = () => {
    // const [showLoader, setShowLoader] = useState(false);
    //
    // useEffect(() => {
    //     setShowLoader(true);
    // }, []);

    const data = {
    };

    const actions = {
    };

    const options = {
    };

    // if (showLoader) {
    //     return <Loader />;
    // }

    return (
        <>
            <div>
                <FrameWorksListView data={data} actions={actions} options={options}/>
            </div>
        </>
    );
}

export default FrameWorksList;